import { render, staticRenderFns } from "./sdkItem.vue?vue&type=template&id=3a44b141&scoped=true&"
import script from "./sdkItem.vue?vue&type=script&lang=js&"
export * from "./sdkItem.vue?vue&type=script&lang=js&"
import style0 from "./sdkItem.vue?vue&type=style&index=0&id=3a44b141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a44b141",
  null
  
)

export default component.exports